(function () {
  "use strict";

  CompositeSearchInputCtrl.$inject = ['$scope', '$rootScope', 'trackingService'];
  angular
    .module('trainerWebApp.controllers')
    .controller('CompositeSearchInputCtrl', CompositeSearchInputCtrl);

  function CompositeSearchInputCtrl($scope, $rootScope, trackingService) {
    var minCharactersToSearch = 1;
    var maxResultsBeforeGroup = 3;

    $scope.searchSelection = [];
    $scope.showClearButton = false;
    var settings = $scope.searchSettings;
    var fields = settings.fields;
    $scope.secondLevelMenuName = null;

    var placeholder = $scope.overridePlaceholder || 'Search...';
    $scope.placeholder = placeholder;

    $scope.selectOptions = {
      width: 'off',
      placeholder: placeholder,
      multiple: true,
      query: query,
      formatInputTooShort: formatInputTooShort,
      minimumInputLength: minCharactersToSearch,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack",
      formatResult: formatResult,
      formatSelection: formatSelection
    };


    function query(query) {
      var data = {results: getAllResults(query.term)};
      query.callback(data);
    }

    function formatResult(object, container, query) {
      var label = escapeHtml(object.label);
      var term = escapeHtml(query.term);
      var text = escapeHtml(object.text);

      if (object.children) {
        container[0].innerHTML = '<span class="pull-right more">more...</span><span>' + text + '</span>';
      } else {
        var html = '<div title="' + text + '"';
        if (object.cssClass) {
          html += ' class="' + object.cssClass + '"';
        }
        html += '>';
        if (label && !object.hideLabelInDropDown)
          html = html + '<span>' + label + ': </span>';
        var startOfCriteriaInResult = text.toLowerCase().indexOf(term.toLowerCase());
        if (startOfCriteriaInResult >= 0) {
          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + text.substr(0, startOfCriteriaInResult) + '</span>';

          html = html + '<span class="select2-match">' + text.substr(startOfCriteriaInResult, term.length) + '</span>';
          if (text.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + text.substr(startOfRestOfResult, text.length - startOfRestOfResult) + '</span>';
          }
        }
        else {
          html = html + '<span>' + text + '</span>';
        }
        html = html + '</div>';
        container[0].innerHTML = html;
      }
    }

    function formatSelection(object, container) {
      if (object.label) {
        return escapeHtml(object.label) + ": " + escapeHtml(object.text);
      }
      return escapeHtml(object.text);
    }

    function escapeHtml(unsafe) {
      if (!unsafe) return unsafe;

      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    $scope.applyEmptyFilter = function () {
      setFilter(null);
    };

    function setFilter(filter, items) {
      $scope.showClearButton = !!filter;
      settings.setFilter(filter);
      if (settings.notifySearchChanged)
        settings.notifySearchChanged(items || []);
    }


    function getAllResults(term) {
      if ($scope.secondLevelMenuName) {
        var groupField = _.find(fields, function (f) {
          return f.groupName == $scope.secondLevelMenuName;
        });
        //We will show fill list only once.
        //$scope.secondLevelMenuName = null;
        var results = getFieldAllResultsForGroup(term, groupField);
        removePrefixes(results, groupField);
        if (groupField.formatResults) {
          results = groupField.formatResults(results, term, /*isSecondLevelMenu:*/true);
        }
        return results;
      }

      var allResults = [];
      var groupResults = true;
      var matchedFieldName = null;
      var colonTerms = term.split(':');
      if (colonTerms.length > 1) {
        var enteredName = colonTerms[0].toLowerCase();
        var matchedField = _.find(fields, function (f) {
          return f.shortcut == enteredName;
        });
        if (matchedField) {
          matchedFieldName = matchedField.name;
          term = colonTerms.slice(1).join(':');
          if (term.length < minCharactersToSearch) {
            return [
              {
                text: matchedField.label + ": Please enter at least " + minCharactersToSearch + " characters.",
                disabled: true
              }
            ];
          }
          groupResults = false;
        }
      }
      _.each(fields, function (f) {
        if (!matchedFieldName || f.name == matchedFieldName) {
          var results = getFieldResults(term, f, groupResults);
          allResults = allResults.concat(results);
        }
      });
      return allResults;
    }

    function getFieldResults(term, field, groupResults) {
      if (field.getSuggestions) {
        var numberOfResultsToGet = groupResults ? maxResultsBeforeGroup + 1 : null;
        var results = getFieldResultsForArray(term, field, field.getSuggestions(), numberOfResultsToGet);
        if (groupResults)
          results = formatFieldResultsGroup(field, results);
        if (field.formatResults)
          results = field.formatResults(results, term, /*isSecondLevelMenu:*/false);

        return results;
      }
      else {
        $scope.secondLevelMenuName = null;
        var filter = field.createFilterSync(term);
        if (settings.filterHasResults(filter)) {
          return [
            {
              id: field.label + "|" + term,
              label: field.label,
              text: term,
              filter: filter,
              track: field.track
            }
          ];
        }
      }

      return [];
    }

    function removePrefixes(results, field) {
      _.each(results, function (result) {
        result.hideLabelInDropDown = true;
      });
    }

    function getFieldAllResultsForGroup(term, field) {
      return getFieldResultsForArray(term, field, field.getSuggestions(), 0);
    }

    function formatFieldResultsGroup(field, results) {
      if (results.length > maxResultsBeforeGroup) {
        removePrefixes(results, field);

        return [
          {
            id: field.groupName + "|",
            name: field.groupName,
            text: field.groupLabel,
            children: results.slice(0, maxResultsBeforeGroup),
            track: field.track
          }
        ];
      }
      return results;
    }

    function getFieldResultsForArray(term, field, array, max) {
      var itemsMatchedByName = filterArrayByNameMatch(array, term);
      var results = [];
      var selectedItemIds = _.pluck($scope.getSelectedItems(), 'dataForFilter');

      for (var i = 0; i < itemsMatchedByName.length; i++) {
        var item = itemsMatchedByName[i];
        if (selectedItemIds.indexOf(item.id) >= 0)
          continue;

        results.push({
          id: field.label + "|" + item.id,
          label: field.label,
          text: item.name,
          field: field,
          dataForFilter: item.id,
          track: field.track
        });

        if (max && results.length == max)
          break;
      }
      return results;
    }

    $scope.searchChanged = function (selectedItems) {
      function createCompositeFilter(filters) {
        return function (user) {
          if (filters.length == 0)
            return true;

          return _.every(filters, function (f) {
            return f(user);
          });
        };
      }

      function commitSearchChanges(items) {
        $scope.secondLevelMenuName = null;
        if (items.length > 1) {
          setFilter(createCompositeFilter(_.pluck(items, 'filter')), items);
          trackingService.trackEvent(
            settings.gaPageName,
            trackingService.pages.usersManage.actions.compositeSearch);
        } else if (items.length == 1) {
          setFilter(items[0].filter, items);
        }
      }

      if (selectedItems.length == 0) {
        $scope.secondLevelMenuName = null;
        $scope.applyEmptyFilter();
        return;
      }

      var itemWithoutFilter = _.find(selectedItems, function (f) {
        return !f.filter;
      });

      if (!itemWithoutFilter)
        return commitSearchChanges(selectedItems);

      if (!itemWithoutFilter.field) return;

      if (itemWithoutFilter.field.createFilterAsync) {
        $rootScope.$broadcast('$showLoadingSpinner', true);
        itemWithoutFilter.field.createFilterAsync(itemWithoutFilter.dataForFilter, function (filter) {
          $rootScope.$broadcast('$showLoadingSpinner', false);
          itemWithoutFilter.filter = filter;
          commitSearchChanges(selectedItems);
        });
      }
      else {
        itemWithoutFilter.filter = itemWithoutFilter.field.createFilterSync(itemWithoutFilter.dataForFilter);
        commitSearchChanges(selectedItems);
      }
    };

    function filterArrayByNameMatch(array, searchCriteria) {
      var searchCriteria = searchCriteria.toLowerCase();
      return _.filter(array, function (value) {
        return ~value.name.toLowerCase().indexOf(searchCriteria);
      });
    }

    function formatInputTooShort(term, minLength) {
      if (term.length == 0)
        $scope.secondLevelMenuName = null;

      var secondLevelName = "";
      if ($scope.secondLevelMenuName != null) {
        secondLevelName = _.find(fields, function (f) {
          return f.groupName == $scope.secondLevelMenuName;
        }).groupLabel;
      }

      return secondLevelName + $scope.overridePlaceholder;
    }
  }

})();
